import { useEffect } from 'react';
import type { ItemSlot as ItemSlotType } from '../types';
import { parseItemLink, wowheadAttr, refreshWowheadTooltips, iconUrl } from '../lib/wow';

interface Props {
  slot: ItemSlotType | undefined;
  slotName: string;
}

export function ItemSlot({ slot, slotName }: Props) {
  const parsed = parseItemLink(slot?.link);
  const attr = wowheadAttr(parsed);

  useEffect(() => {
    refreshWowheadTooltips();
  }, [slot?.id]);

  if (!slot || !slot.id) {
    return (
      <div className="item-slot item-slot-empty" title={slotName}>
        <div className="item-slot-icon" aria-hidden />
        <div className="item-slot-text">
          <div className="item-slot-label">{slotName}</div>
          <div className="item-slot-name item-slot-empty-label">Empty</div>
        </div>
      </div>
    );
  }

  const icon = iconUrl(slot.texture);
  const qColor = parsed?.qualityColor || '#ffffff';
  const itemName = parsed?.name || `Item #${slot.id}`;

  const durability =
    slot.durMax && slot.durMax > 0
      ? `${slot.durCurrent ?? 0}/${slot.durMax}`
      : null;

  return (
    <a
      className="item-slot"
      href={`https://www.wowhead.com/wotlk/item=${slot.id}`}
      data-wowhead={attr}
      target="_blank"
      rel="noreferrer"
      style={{ borderColor: 'transparent' }}
    >
      <div
        className="item-slot-icon"
        style={{ borderColor: qColor, boxShadow: `0 0 8px ${qColor}55` }}
      >
        {icon && (
          <img
            src={icon}
            alt=""
            loading="lazy"
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
        )}
      </div>
      <div className="item-slot-text">
        <div className="item-slot-label">{slotName}</div>
        <div className="item-slot-name" style={{ color: qColor }}>
          {itemName}
        </div>
        {durability && (
          <div className="item-slot-meta">Durability {durability}</div>
        )}
      </div>
    </a>
  );
}
